import ArchiveOrdersPage from "../components/pages/orders/ArchiveOrdersPage.jsx";
import OrdersPage from "../components/pages/orders/OrdersPage.jsx";
import ReordersPage from "../components/pages/orders/ReordersPage.jsx";

const routes = [
    {
        path: "/orders",
        element: <OrdersPage />
    },
    {
        path: "/orders/reorders",
        element: <ReordersPage />
    },
    {
        path: "/orders/archive",
        element: <ArchiveOrdersPage />
    }
];

export default routes;
